export const getBackendHost = () => {
  return import.meta.env.VITE_GENERAL_PURPOSE_HOST_URL;
};

export const getToitsHost = () => {
  return import.meta.env.VITE_TOITS_HOST
}
